/**
 * Directive: vcardEditContact
 */
angular.module('acme.common.directive.vcardEditContact', [
  'acme.common.service.validate'
])
.directive('vcardEditContact', ['$timeout', 'ValidateService', function($timeout, ValidateService) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/vcard/edit/contact/contact.tpl.html',
      scope: {
        model: '=',
        addresses: '=',
        validate: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.vcardEditContact = {
          addressFields: ['streetAddress1', 'streetAddress2', 'city', 'state', 'country', 'zipCode'],
          selectedAddress: {},
          address: {},
          addressType: 'existing',

          errors: [],
          titles: [
            {
              title: 'ms',
              name: 'Ms'
            },
            {
              title: 'miss',
              name: 'Miss'
            },
            {
              title: 'mrs',
              name: 'Mrs'
            },
            {
              title: 'mr',
              name: 'Mr'
            },
            {
              title: 'rev',
              name: 'Rev'
            },
            {
              title: 'dr',
              name: 'Dr'
            },
            {
              title: 'prof',
              name: 'Prof'
            }
          ],

          init: function() {
            if (($scope.addresses instanceof Array) && !$scope.addresses.length) {
              this.addressType = 'new';
            } else {
              this.selectedAddress = $scope.addresses[$scope.addresses.length-1];
            }

            $scope.$on('VcardContact::Process', this.onProcess);
            $scope.$on('AddressCreate::Complete', this.onAddressCreateComplete);
            $scope.$on('AddressCreate::Error', this.onAddressCreateError);
          },

          onProcess: function(e, data) {
            var self = $scope.vcardEditContact;

            if (self.useValidation()) {
              if (self.address) {
                switch(self.addressType) {
                  case 'new':  $scope.$broadcast('AddressCreate::Process');
                    break;
                  case 'existing': self.done();
                    break;
                }
              } else {
                self.done();
              }
            }
          },

          deNormalizeAddress: function() {
            var keys = [].concat(this.addressFields);

            if ((this.selectedAddress !== undefined) && this.selectedAddress.hasOwnProperty('name')) {
              //delete this or the model's name will get updated.
              delete(this.selectedAddress.name);
            }

            if (this.addressType  === 'existing') {
              this.address = this.selectedAddress;
            }

            if (!this.address) {
              this.address = {};
              keys.forEach(function(key) {
                $scope.vcardModal.address[key] = null;
              });
            }

          },

          newAddressAdded: function(added) {
            if (added) {
              this.addressType = 'new';
            } else {
              this.addressType = 'existing';
            }
          },

          validateAddress: function() {
            var addressName = this.addressType === 'existing' ? this.selectedAddress.name : this.address.streetAddress1,
              r = true;
            if (this.useValidation()) {
              r = (!!addressName);
            }
            return r;
          },

          useValidation: function() {
            return ($scope.validate !== undefined) && ($scope.validate === 'true');
          },

          getValidators: function() {
            var self = this,
              validators,
              contactValidators = {
                name: [
                  { field: 'vcard-edit-contact-first-name', len: { message: 'Invalid name', test: { value: $scope.model.firstName } } },
                  { field: 'vcard-edit-contact-last-name', len: { message: 'Invalid name', test: { value: $scope.model.lastName } } },
                ],
                contact: [
                  { field: 'vcard-edit-contact-email', email: { message: 'Invalid email', test: function() { return $scope.model.email; } } },
                  { field: 'vcard-edit-contact-phone', phone: { message: 'Invalid phone number', test: function() { return $scope.model.phoneNumber; } } }
                ],
                address: [
                  { field: 'vcard-edit-contact-address', len: { message: 'Invalid address', test: { value: this.address.streetAddress1 } } }
                ]
              };

            validators = contactValidators.name.concat(contactValidators.contact);

            if (this.useValidation()) {
              validators = validators.concat(contactValidators.address);
            }

            return validators;
          },

          done: function() {
            var self = $scope.vcardEditContact;

            self.deNormalizeAddress();

            if (ValidateService.validate(self.getValidators())) {
              $scope.$emit('VcardContact::Complete');
            } else {
              self.errors = ValidateService.getErrorHash();
            }
          },

          onAddressCreateComplete: function(e, data) {
            var self = $scope.vcardEditContact;
            self.address = data.address;
            self.done();
          },

          onAddressCreateError: function(e, data) {
            // var self = $scope.vcardModal;
          }

        };

        $scope.vcardEditContact.init();

      }]

    };

}]);